import { X, Printer } from "lucide-react";
import ThermalReport from "./ThermalReport";

export default function RelatorioTermicoModal({
  open,
  onClose,
  titulo,
  escopo,
  periodo,
  vendas,
  mode = "completo",
  hideProfitCost = false,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white border-4 border-neutral-900 w-full max-w-md max-h-[92vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b-2 border-neutral-900 print:hidden">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
              Preview térmico 80mm
            </p>
            <h3 className="font-display font-black text-lg tracking-tight">
              Relatório {mode === "resumido" ? "Resumido" : "Completo"}
            </h3>
          </div>
          <div className="flex gap-2">
            <button
              data-testid="relatorio-dia-imprimir"
              onClick={() => window.print()}
              className="bg-yellow-400 text-neutral-950 h-10 px-4 font-display font-bold uppercase text-xs tracking-widest flex items-center gap-2"
            >
              <Printer className="w-4 h-4" /> Imprimir
            </button>
            <button
              data-testid="relatorio-dia-fechar"
              onClick={onClose}
              className="p-2 border-2 border-neutral-900 hover:bg-neutral-900 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-4 bg-neutral-50">
          <ThermalReport
            titulo={titulo}
            periodo={periodo}
            escopo={escopo}
            vendas={vendas}
            mode={mode}
            hideProfitCost={hideProfitCost}
          />
        </div>
      </div>
    </div>
  );
}
